export const INTRODUCTORY_BLOCK_ID = "introductory-question";

export const ASSESSMENT_EVIDENCE_FILTER_ALL = "All";

export const ASSESSMENT_WORKFLOW_OPTIONS = [
  "created",
  "drafting",
  "le_review",
  "pm_review",
  "approved",
] as const;
